import { Checkbox, DatePicker, Form, Input, TimePicker } from "antd";
import { Container } from "../../../../common/components/container/Container";
import { GoBack } from "../../../../common/components/GoBack/GoBack";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import style from "./style.module.scss";
import { SimpleInput } from "../../../../common/components/simpleInput";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import "./style.scss";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { useLocation, useNavigate } from "react-router";
// import { UploadInputFile } from "../../../../common/components/Upload/UploadInputFile";
import Spinner from "../../../../common/components/Spinner/Spinner";
import { CommercialOperation } from "../../core/_request";
// import { createFormData } from "../../../../utilities/formData";
// import { API_BASE_URL } from "../../../../utilities/API_CONSTANT";
// import { AiOutlineCloudDownload } from "react-icons/ai";
import { HttpStatusCode } from "axios";
import { OperationType, useOperationType } from "../../core/_context";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { IoIosAdd } from "react-icons/io";
import { RiDeleteBin5Line } from "react-icons/ri";
import { API_URLs } from "../../../../utilities/API_URLs";
import dayjs from "dayjs";
import { handleNumericDecimalChange, handleNumericDecimalInput } from "../../../../common/utils/numericInputHandler";

const STATIC_FILES_NAME = {
  MANIFESTE: "manifestFile",
  COMMANDE_PJ: "teamOrderFile",
  AVIS_PJ: "arrivalNoticeFile",
  LANDING: "mscDebarkationFile",
  EMPTY_BOARDING: "mscEmptyEmbarkationFile",
  FULL_BOARDING: "mscFullEmbarkationFile",
};

type PropsType = {
  operationType?: OperationType;
};

export const BasicInformation = ({ operationType = "unknown" }: PropsType) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const location = useLocation();
  const isSales = location.pathname.includes("/sales-operations");

  const [selectedOperationType, setSelectedOperationType] = useState<
    string | null
  >(null);

  const [sectionErrors, setSectionErrors] = useState<{
    embarkation?: boolean;
    debarkation?: boolean;
  }>({});

  const isEmbarkation = selectedOperationType === "EMBARKATION";
  const isDebarkation = selectedOperationType === "DEBARKATION";
  const isBoth = selectedOperationType === "EMBARKATION_DEBARKATION";

  const [checked, setChecked] = useState<boolean>(false); 

  const onHandleChecked = () => {
    setChecked((prev: any) => !prev);
  }

  const OperationBlock = ({
    title,
    prefix,
  }: {
    title: string;
    prefix: "embarkation" | "debarkation";
  }) => {    
    const [containers, setContainers] = useState<any[]>([]);
    const [others, setOthers] = useState<any[]>([]);

    const [selectedLoadFillingStatus, setSelectedLoadFillingStatus] = useState<{ [key: number]: string }>({});
  
    const addContainer = () => {
      setContainers((prev) => [...prev, {}]);
      
    };

    const removeContainer = (index: number) => {
      const current = form.getFieldValue(prefix)?.containers || [];
    
      // supprimer la ligne
      const updated = current.filter((_: any, i: number) => i !== index);
    
      // mettre à jour le form
      form.setFieldsValue({
        [prefix]: {
          ...form.getFieldValue(prefix),
          containers: updated,
        },
      });
    
      setContainers(updated);
    };

    const addOther = () => {
      setOthers((prev) => [...prev, {}]);
      /* setSectionErrors((prev) => ({
        ...prev,
        [prefix]: false,
      })); */
    };

    const removeOther = (index: number) => {
      const current = form.getFieldValue(prefix)?.others || [];
    
      const updated = current.filter((_: any, i: number) => i !== index);
    
      form.setFieldsValue({
        [prefix]: {
          ...form.getFieldValue(prefix),
          others: updated,
        },
      });
    
      setOthers(updated);
    };

    return (
      <>
      <div className={style.basic__movement_container }>
        <p className={style.basic__title}>{title}</p>

        {/* CONTENEURS */}
        <span>Conteneurs</span>
        <br />

        {containers.map((_, index) => {
          const filled =
          selectedLoadFillingStatus[index] ===
          "/api/load_filling_statuses/FILLED";

          return (
          <div key={index}>
            {/* LES 5 INPUTS */}
            <div className={style.basic__form_first_content}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={[prefix, "containers", index, "reference"]}
                  label="Référence"
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={<Input />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={[prefix, "containers", index, "loadFillingStatus"]}
                  label="Etat"
                  rules={[
                    { required: true, message: "Ce champs est obligatoire" },
                  ]}
                  customInput={
                    <InputSelect
                      onChange={(e) => {
                        setSelectedLoadFillingStatus((prev) => ({
                          ...prev,
                          [index]: e?.value,
                        }));
                      }}
                      uri="/api/load_filling_status/select"
                    />
                  }
                />
              </div>

              {filled && (
                <div className={style.basic__form_first_content_item}>
                  <SimpleInput
                    Form={Form}
                    name={[prefix, "containers", index, "sealNumber"]}
                    label="N° Plomb"
                    rules={[
                      {
                        required: true,
                        message: "Ce champs est obligatoire",
                      },
                    ]}
                    customInput={<Input />}
                  />
                </div>
              )}
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={[prefix, "containers", index, "containerType"]}
                  label="Type"
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={
                    <InputSelect
                      onChange={() => {}}
                      uri="/api/container_types/select"
                      style={{minWidth: "125%"}}
                      params={{itemsPerPage: 99999}}
                    />
                  }
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={[prefix, "containers", index, "tonnage"]}
                  label="Tonnage"
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={<Input onKeyDown={handleNumericDecimalInput} onChange={handleNumericDecimalChange}/>}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <RiDeleteBin5Line
                  className={style.basic__delete_icon}
                  title="Supprimer"
                  onClick={() => removeContainer(index)}
                />
              </div>
              {!filled && (
                <div className={style.basic__form_first_content_item}></div>
              )}
            </div>
          </div>
          );
        })}
        <button
          className={style.basic__add_btn}
          type="button"
          onClick={addContainer}
        >
          <IoIosAdd /> Ajouter
        </button>
        <br />
        <br />

        {/* AUTRES */}
        <span>Autres</span>
        <br />

        {others.map((_, index) => (
          <div key={index}>
            {/* LES 4 INPUTS */}
            <div className={style.basic__form_first_content}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={[prefix, "others", index, "label"]}
                  label="Label"
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={<Input />}
                />
              </div>
              <div
                className={`${style.basic__form_first_content_item}`}
                style={{ display: "flex", flexDirection: "row", gap: 10 }}
              >
                <div style={{ flex: 3 / 5 }}>
                  <SimpleInput
                    Form={Form}
                    name={[prefix, "others", index, "quantity"]}
                    label="Quantité"
                    rules={[
                      {
                        required: true,
                        message: "Ce champs est obligatoire",
                      },
                    ]}
                    customInput={<Input />}
                  />
                </div>
                <div style={{ flex: 2 / 5 }}>
                  <SimpleInput
                    Form={Form}
                    name={[prefix, "others", index, "unit"]}
                    label="Unité"
                    rules={[
                      {
                        required: true,
                        message: "Ce champs est obligatoire",
                      },
                    ]}
                    customInput={<Input />}
                  />
                </div>
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={[prefix, "others", index, "description"]}
                  label="Déscription"
                  customInput={<TextArea style={{ height: "20px" }} />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <RiDeleteBin5Line
                  className={style.basic__delete_icon}
                  title="Supprimer"
                  onClick={() => removeOther(index)}
                />
              </div>
              {window.innerWidth > 1024 && (
                <>
                <div className={style.basic__form_first_content_item}></div>
                <div className={style.basic__form_first_content_item}></div>
                </>
              )}
            </div>
          </div>
        ))}
        <button
          className={style.basic__add_btn}
          type="button"
          onClick={addOther}
        >
          <IoIosAdd /> Ajouter
        </button>
      </div>
      {sectionErrors?.[prefix] && (
        <span style={{ color: "#ff4d4f", marginLeft: "10px" }}>
          Veuillez remplir la section ci-dessus.
        </span>
      )}
      </>
    );
  };

  const buildLoads = (data: any) => {
    const containerLoads = (data.containers || []).map((c: any) => ({
      "@type": "ContainerLoad",
      reference: c.reference,
      loadFillingStatus: c.loadFillingStatus?.value,
      sealNumber: c.sealNumber,
      containerType: c.containerType?.value,
      tonnage: c.tonnage,
    }));
  
    const otherLoads = (data.others || []).map((o: any) => ({
      "@type": "OtherLoad",
      label: o.label,
      description: o.description,
      quantity: o.quantity,
      unit: o.unit,
    }));
  
    return [...containerLoads, ...otherLoads];
  };

  const handleSubmiFile = async (values: any) => {
    try {
      setIsLoadingSubmit(true);

      /* const dataToPost = {
        ...values,
        operationCategory: isSales ? "COMMERCIAL" : "CABOTAGE",

        // Toujours envoyés
        [STATIC_FILES_NAME.COMMANDE_PJ]:
          values?.[STATIC_FILES_NAME.COMMANDE_PJ]?.[0]?.originFileObj,
        [STATIC_FILES_NAME.AVIS_PJ]:
          values?.[STATIC_FILES_NAME.AVIS_PJ]?.[0]?.originFileObj,

        // Non MSC
        ...(!checked && {
          [STATIC_FILES_NAME.MANIFESTE]:
            values?.[STATIC_FILES_NAME.MANIFESTE]?.[0]?.originFileObj,
        }),

        // MSC uniquement
        ...(checked && {
          isMsc: 1,
          ...(values?.[STATIC_FILES_NAME.LANDING]?.[0]?.originFileObj && {
            [STATIC_FILES_NAME.LANDING]:
              values[STATIC_FILES_NAME.LANDING][0].originFileObj,
          }),

          ...(values?.[STATIC_FILES_NAME.EMPTY_BOARDING]?.[0]
            ?.originFileObj && {
            [STATIC_FILES_NAME.EMPTY_BOARDING]:
              values[STATIC_FILES_NAME.EMPTY_BOARDING][0].originFileObj,
          }),

          ...(values?.[STATIC_FILES_NAME.FULL_BOARDING]?.[0]?.originFileObj && {
            [STATIC_FILES_NAME.FULL_BOARDING]:
              values[STATIC_FILES_NAME.FULL_BOARDING][0].originFileObj,
          }),
        }),
      }; */

      const { debarkation, embarkation, estimatedHour, ...rest } = values;

      const dataToPost = {
        ...rest,
        operationCategory: operationType == "cabotage" ? "/api/operation_categories/CABOTAGE" : "/api/operation_categories/COMMERCIAL",
        customer: values?.customer ? values?.customer?.value : null,
        estimatedArrivalAt:
        values?.estimatedArrivalAt && values?.estimatedHour
          ? dayjs(values.estimatedArrivalAt)
              .hour(dayjs(values.estimatedHour).hour())
              .minute(dayjs(values.estimatedHour).minute())
              .format("DD/MM/YYYY HH:mm")
          : null,  
        fillManifestDirectly: checked,     
        operationType: values?.operationType ? `/api/operation_types/${values?.operationType?.value}`: null,
        ...((isDebarkation || isBoth) && checked
          ? {
              debarkationMovement: {
                loads: buildLoads(values.debarkation),
              },
            }
          : {}),
      
          ...( ((isEmbarkation || isBoth) && embarkation) && checked
          ? {
              embarkationMovement: {
                loads: buildLoads(values.embarkation),
              },
            }
          : {}),
      }

      const res = await CommercialOperation.createOperations(dataToPost);

      // JSON.stringify(console.log("payload: ", dataToPost));

      if (res?.status === HttpStatusCode.Ok || res?.status === HttpStatusCode.Created) {
        const newPath = isSales
          ? `/app/operations/sales-operations/operation/${res?.data?.id}`
          : `/app/operations/cabotage/operation/${res?.data?.id}`;

        navigate(newPath);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

/*   const [checked, setChecked] = useState<boolean>(false);

  const onChecked = () => {
    setChecked((prev: boolean) => !prev);
  }; */

  return (
    <div className={style.basic}>
      <div className={style.basic__header}>
        <GoBack />
        <div>
          <span>
            Nouvelle opération {isSales ? "commerciale" : "de cabotage"}
          </span>
        </div>
      </div>
      <Container>
        <div className="">
          <p className={style.basic__title}>Informations de la demande</p>
        </div>

        <FormProvider
          Form={Form}
          form={form}
          debug
          onFinish={(values) => {
            const hasEmbarkation =
              values?.embarkation?.containers?.length ||
              values?.embarkation?.others?.length;

            const hasDebarkation =
              values?.debarkation?.containers?.length ||
              values?.debarkation?.others?.length;

            const errors: any = {};

            if (checked) {
              if (isBoth) {
                if (!hasEmbarkation && !hasDebarkation) {
                  errors.debarkation = true;
                }
              } else {
                if (isEmbarkation && !hasEmbarkation) {
                  errors.embarkation = true;
                }
              
                if (isDebarkation && !hasDebarkation) {
                  errors.debarkation = true;
                }
              }
            }

            // 👉 S'il y a au moins une erreur → stop
            if (Object.keys(errors).length > 0) {
              setSectionErrors(errors);
              return;
            }

            // reset erreurs si tout est OK
            setSectionErrors({});
            handleSubmiFile(values);
          }}
          onFinishFailed={(err) => {
            console.log("err", err);
          }}
        >
          <div className={style.basic__form_container}>
          <div className={`${style.basic__form_first_content} ${style.basic__form_first_content_responsive}`}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={`${
                    operationType == "cabotage" ? "reference" : "travelReference"
                  }`}
                  label={`Référence ${operationType == "cabotage" ? "commande Équipe" : "du voyage"}`}
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={<Input />}
                />
              </div>
              <div style={{flex: 1, marginTop: "20px", display: "flex", flexDirection: "row", gap: 10}}>
                <div  style={{ flex: 3/4 }}>
                <SimpleInput
                  Form={Form}
                  name={"estimatedArrivalAt"}
                  label="ETA (jour)"
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={<DatePicker className="w-100"/>}
                />
                </div>
                <div  style={{ flex: 1/4 }}>
                <SimpleInput
                  Form={Form}
                  label="(heure)"
                  name={"estimatedHour"}
                  rules={[
                    {
                      required: true,
                      message: `Ce champ est requis`,
                    },
                  ]}
                  customInput={
                    <TimePicker
                      style={{ width: "100%" }}
                      needConfirm={false}
                      format={"HH:mm"}
                      showNow={false}
                    />
                  }
                />
                </div> 
              </div>
            </div>
            <div className={style.basic__form_first_content}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={"ship"}
                  label="Navire"
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={<Input />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={"customer"}
                  label="Client"
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={<InputSelect onChange={() => {}} uri={API_URLs.settings.customers.getCustomerSelect} />}
                />
              </div>
            </div>
            {operationType == "cabotage" ? (
              <>
                <div className={style.basic__form_first_content}>
                  <div className={style.basic__form_first_content_item}>
                    <SimpleInput
                      Form={Form}
                      name={"operationType"}
                      label="Type d'opération"
                      rules={[
                        {
                          required: true,
                          message: "Ce champs est obligatoire",
                        },
                      ]}
                      customInput={
                        <InputSelect
                          uri="api/operation_types/select"
                          isNotUri
                          onChange={(e) => {
                            setSelectedOperationType(e?.value);
                          }}
                        />
                      }
                    />
                  </div>
                </div>

                {/* TEXT CONDITIONNING OPERATION BLOCK SECTION DISPLAY */}
                <Checkbox className={style.msc_text} checked={checked} onClick={onHandleChecked}>Remplir manuellement</Checkbox>

                {/* LOADS ACCORDING TO OPERATION TYPE */}

                {((isDebarkation || isBoth) && checked) && (
                  <OperationBlock
                    title="Débarquement"
                    prefix="debarkation"
                    // onChange={() => setDebarkationData}
                />
                )}

                {((isEmbarkation || isBoth) && checked) && (
                  <OperationBlock
                    title="Embarquement"
                    prefix="embarkation"
                    // onChange={() => setEmbarkationData}
                />
                )}
              </>
            ) : (
              ""
            )}
            {/* FIRST LINE : Résumé commercial, Pièce jointe CÉ, Pièce jointe AA */}
            {/* <div className={style.basic__form_first_content}>
              { !checked && (
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.MANIFESTE}
                  label={`${
                    operationType === "cabotage"
                      ? "Manifeste"
                      : "Résumé commercial"
                  } `}
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={<UploadInputFile isExcelOnly />}
                />
                <div className={style.basic__link_wrapper}>
                  <a
                    href={
                      isSales
                        ? `${API_BASE_URL}/templates/resume_commercial.xlsx`
                        : `${API_BASE_URL}/templates/manifeste.xlsx`
                    }
                    download
                    target="_blank"
                    className={style.basic__link}
                  >
                    <AiOutlineCloudDownload
                      className={style.basic__link_icon}
                    />{" "}
                    Télécharger le modèle
                  </a>
                </div>
              </div>)}
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.COMMANDE_PJ}
                  label="Pièce jointe (commande équipe)"
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={<UploadInputFile isExcelOnly />}
                />
                <div className={style.basic__link_wrapper}>
                  <a
                    href={
                      isSales
                        ? `${API_BASE_URL}/templates/commande_equipe_commercial.xlsx`
                        : `${API_BASE_URL}/templates/commande_equipe_cabotage.xlsx`
                    }
                    download
                    target="_blank"
                    className={style.basic__link}
                  >
                    <AiOutlineCloudDownload
                      className={style.basic__link_icon}
                    />{" "}
                    Télécharger le modèle
                  </a>
                </div>
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.AVIS_PJ}
                  label="Pièce jointe (Avis d'arrivée)"
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={<UploadInputFile isExcelOnly />}
                />
                <div className={style.basic__link_wrapper}>
                  <a
                    href={
                      isSales
                        ? `${API_BASE_URL}/templates/avis_arrivee_commercial.xlsx`
                        : `${API_BASE_URL}/templates/avis_arrivee_cabotage.xlsx`
                    }
                    download
                    target="_blank"
                    className={style.basic__link}
                  >
                    <AiOutlineCloudDownload
                      className={style.basic__link_icon}
                    />{" "}
                    Télécharger le modèle
                  </a>
                </div>
              </div>
              { checked && (<div className={style.basic__form_first_content_item}>
                
              </div>)}
            </div> */}
            {/* CHAMPS MSC */}
            {/* isSales && (
            <Checkbox className={style.msc_text} onChange={onChecked}>Importer des fichiers MSC</Checkbox>
          ) */}
            {/* checked && (<div className={style.basic__form_first_content}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.LANDING}
                  label={"Ficher de débarquement"}
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.EMPTY_BOARDING}
                  label="Fichier d'embarquement vide"
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.FULL_BOARDING}
                  label="Fichier d'embarquement plein"
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
            </div>)*/}
            {/* NOTES */}
            {/* <div className={style.basic__form_first_content}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={"notes"}
                  label="Notes"
                  customInput={<TextArea rows={6} />}
                />
              </div>
            </div> */}
          </div>
          {/* BOUTON */}
          <div className={style.basic__footer}>
            <CustomButton
              backgroundColor="#72A4FC"
              className={style.basic__footer_button}
            >
              {isLoadingSubmit ? <Spinner /> : <span>Créer opération </span>}
            </CustomButton>
          </div>
        </FormProvider>
      </Container>
    </div>
  );
};
